/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Routes 

export const USER_ACCOUNT_ROUTE = '/accounts';
export const USER_ACCOUNT_BALANCE_ROUTE = '/accounts/balance';
export const USER_ACCOUNT_BALANCE_SOURCE_ROUTE = '/accounts/balance/source';
export const USER_HISTORY_ENTRY_ROUTE = '/history/users';
export const BALANCE_CHANGE_LOG_ROUTE = '/accounts/balance/change/logs';
export const INTERNATIONAL_USER_BANK_ACCOUNT_ROUTE = '/accounts/user/bank/accounts/international';
export const US_DOMESTIC_USER_BANK_ACCOUNT_ROUTE = '/accounts/user/bank/accounts/us/domestic';
export const USER_BANK_ACCOUNT_DELTA_ROUTE = '/accounts/user/bank/accounts/deltas';
export const USER_ACCOUNT_SETTINGS_ROUTE = '/accounts/settings';
export const ADMIN_GHOST_USER_ACCOUNT_ROUTE = '/accounts/admin/ghost/user';
export const USER_ACCOUNT_FINALIZATION_ROUTE = '/accounts/finalize';
export const THIRD_PARTY_USER_ACCOUNT_MAPPING_ROUTE = '/accounts/third/party/acc/mapping';
export const PREVIOUS_EMAIL_ADDRESS_ROUTE = '/accounts/email/previous';
export const PENDING_EMAIL_CHANGE_ROUTE = '/accounts/email/changes/pending';
export const ARCHIVED_PENDING_EMAIL_CHANGE_ROUTE = '/accounts/email/changes/pending/archived';
export const PASSWORD_ROUTE = '/accounts/passwords';
export const EXPIRED_PASSWORD_ROUTE = '/accounts/password/expired';
export const PASSWORD_RESET_ROUTE = '/accounts/password/resets';
export const DEPOSIT_ROUTE = '/deposits';
export const DEPOSIT_INVITE_ROUTE = '/deposits/invites';
export const DEPOSIT_ADJUSTMENT_ROUTE = '/deposits/adjustments';
export const DEPOSIT_INTEREST_ROUTE = '/deposits/interest';
export const DEPOSIT_HISTORY_ENTRY_ROUTE = '/history/deposits';
export const DEPOSIT_CLOSE_REQUEST_ROUTE = '/deposits/close-requests';
export const DEPOSIT_USER_STATS_ROUTE = '/deposits/user-stats';
export const DEPOSIT_BANK_MAPPING_ROUTE = '/deposits/bank-mapping';
export const DEPOSIT_BULK_IMPORT_ROUTE = '/deposits/bulk-imports';
export const DEPOSIT_INTEREST_LOG_ROUTE = '/deposits/interest/log';
export const ARCHIVED_DEPOSIT_CLOSE_REQUEST_ROUTE = '/deposits/close-requests/archived';
export const DEPOSIT_WITHHELD_FUNDS_ROUTE = '/deposits/withheld/funds';
export const PMC_REPORT_TIMETABLE_ROUTE = '/deposits/pmc/report/timetable';
export const DEPOSIT_GROUP_ROUTE = '/deposits/collections';
export const DEPOSIT_POST_CLOSE_ADJUSTMENT_ROUTE = '/deposits/adjustments/post-close';
export const DEPOSIT_USER_GROUP_ROUTE = '/deposits/user/groups';
export const PROPERTY_GROUP_ROUTE = '/deposits/properties/groups';
export const PROPERTY_USER_GROUP_ROUTE = '/deposits/properties/groups/user';
export const DISPUTE_ROUTE = '/deposits/disputes';
export const DISPUTE_SPLIT_ROUTE = '/deposits/disputes/splits';
export const DISPUTE_INTERVENTION_REQUEST_ROUTE = '/deposits/disputes/intervention-requests';
export const PROPERTY_ROUTE = '/deposits/properties';
export const PROPERTY_ADDRESS_ROUTE = '/deposits/properties/addresses';
export const COMPLIANCE_ROUTE = '/deposits/compliance';
export const COMPLIANCE_RULE_ROUTE = '/deposits/compliance-rules';
export const COMPLIANCE_HISTORY_ROUTE = '/deposits/compliance-history';
export const EMAIL_TEMPLATE_ROUTE = '/messaging/emails/templates';
export const EMAIL_VERIFICATION_ROUTE = '/accounts/email/verifications';
export const EMAIL_VERIFICATION_RECORD_ROUTE = '/accounts/email/verification/records';
export const EMAIL_EVENT_ROUTE = '/messaging/emails/events';
export const SENT_EMAIL_ROUTE = '/messaging/emails/sent';
export const MAILBOX_ROUTE = '/messaging/mailboxes';
export const MAILBOX_META_DATA_ROUTE = '/messaging/mailbox/meta-data';
export const MAILBOX_MESSAGE_ROUTE = '/messaging/mailbox/messages';
export const PERMISSION_ENTRY_ROUTE = '/permissions/entries';
export const PERMISSION_LOG_ENTRY_ROUTE = '/permissions/logs';
export const PERMISSIONS_ORGANIZATION_SETTINGS_ROUTE = '/permissions/orgs/settings';
export const RESOURCE_PERMISSION_ROUTE = '/permissions/resource/permissions';
export const ORGANIZATION_ROUTE = '/permissions/organizations';
export const ORGANIZATION_RESOURCE_PERMISSION_RULE_ROUTE = '/permissions/organizations/resource/permission/rule';
export const INVOICE_ROUTE = '/payments/invoices';
export const INVOICE_ITEM_ROUTE = '/payments/invoice/item';
export const PAYMENT_REQUEST_ROUTE = '/payments/requests';
export const STRIPE_PAYMENT_LOG_ROUTE = '/payments/stripe/logs';
export const USER_WITHDRAW_ROUTE = '/payments/withdrawals';
export const PRIORITY_ACH_PAYMENT_ROUTE = '/payments/priority/payments/ach';
export const PRIORITY_ACH_RECURRING_PAYMENT_ROUTE = '/payments/priority/payments/ach/recurring';
export const LOAN_APPLICATION_ROUTE = '/payments/deposit/loan/request';
export const LOAN_SYSTEM_INFO_ROUTE = '/payments/deposit/loan/system';
export const LOAN_ROUTE = '/payments/loan';
export const LOAN_HISTORY_ROUTE = '/payments/loan/history';
export const LOAN_PAYMENT_LOG_ROUTE = '/payments/loan/payment/log';
export const STRIPE_WEBHOOK_LOG_ROUTE = '/payments/stripe/webhook/log';
export const USER_ACCOUNT_PAYMENT_PROVIDER_INFO_ROUTE = '/payments/user/payment/provider';
export const SEZZLE_ORDER_ROUTE = '/payments/sezzle/order';
export const SEZZLE_WEBHOOK_EVENT_ROUTE = '/payments/sezzle/webhook/events';
export const BANK_ACCOUNT_ROUTE = '/banking/account';
export const BANK_ACCOUNT_HISTORICAL_INTEREST_RATE_ROUTE = '/banking/interest/history';
export const BANK_ACCOUNT_INTEREST_ROUTE = '/banking/interest';
export const BANK_ACCOUNT_BALANCE_RECORD_ROUTE = '/accounts/balance/record';
export const BANK_TRANSFER_ROUTE = '/banking/';
export const BULK_FUNDS_TRANSFER_ROUTE = '/banking/';
export const FUNDS_LOCK_ROUTE = '/accounts/funds/locks';
export const FUNDS_LOCK_RELEASE_LOG_ROUTE = '/accounts/funds/locks/release/log';
export const RELEASED_FUNDS_LOCK_ROUTE = '/accounts/funds/locks/released';
export const BALANCE_SOURCE_TRANSFER_ROUTE = '/accounts/balance/source/transfers';
export const CREDIT_USER_ACCOUNT_LOG_ROUTE = '/accounts/credit/logs';
export const EVENT_ROUTE = '/events';
export const EVENT_HOOK_ROUTE = '/events/hook';
export const NOTIFICATION_ROUTE = '/events/notifications';
export const ACTION_ITEM_ROUTE = '/events/action-items';
export const UPDATE_LOG_ROUTE = '/history/update/logs';
export const STORAGE_FILE_ROUTE = '/storage/files';
export const ATTACHED_STORAGE_FILES_ROUTE = '/storage/attached/files';
export const SYSTEM_HISTORY_ENTRY_ROUTE = '/history/system';
export const SNAPSHOT_ROUTE = '/history/snapshot';
export const IP_ADDRESS_ROUTE = '/security/ip-addresses';
export const KNOWN_IP_ADDRESS_ROUTE = '/security/known-ip-addresses';
export const USER_AGENT_ROUTE = '/security/user-agents';
export const KNOWN_USER_AGENT_ROUTE = '/security/known/user-agents';
export const SYSTEM_STATS_ROUTE = '/system/general/system/stats';
export const RESOURCE_NOTE_ROUTE = '/system/general/resource/notes';
export const DEPOSIFY_TAG_ROUTE = '/system/general/deposify/tags';
export const PERMANENT_LINK_ROUTE = '/system/general/permanent/links';
export const ONLINE_USER_ROUTE = '/frontend/online/users';
export const FRONTEND_GENERAL_SETTINGS_ROUTE = '/frontend/general/settings';
export const YARDI_SCREENING_WORKS_PRO_XML_ROUTE = '/yardi/screening/works/pro/xml';
export const YARDI_VOYAGER_XML_ROUTE = '/yardi/voyager_xml';
export const YARDI_VOYAGER_TRANSACTION_ROUTE = '/yardi/voyager_transaction';
export const YARDI_VOYAGER_RESIDENT_ROUTE = '/yardi/voyager_resident';
export const YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN_ROUTE = '/yardi/voyager_resident_custom_column';
export const YARDI_VOYAGER_PROPERTY_UNIT_ROUTE = '/yardi/voyager_property_unit';
export const YARDI_VOYAGER_PROPERTY_ROUTE = '/yardi/voyager_property';
export const YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION_ROUTE = '/yardi/voyager_pmc_service_interface_version';
export const YARDI_VOYAGER_PMC_ROUTE = '/yardi/voyager_pmc';
export const YARDI_VOYAGER_PMC_CREDENTIALS_ROUTE = '/yardi/voyager_pmc_credentials';
export const YARDI_VOYAGER_PET_ROUTE = '/yardi/voyager_pet';
export const YARDI_VOYAGER_ILS_GUEST_CARD_EVENT_ROUTE = '/yardi/voyager_ils_guest_card_event';
export const YARDI_VOYAGER_CHARGE_ROUTE = '/yardi/voyager_charge';
export const YARDI_VOYAGER_CHARGE_CODE_ROUTE = '/yardi/voyager_charge_code';
export const YARDI_VOYAGER_DEPOSIT_CREATE_INTENT_ROUTE = '/yardi/voyager_deposit_create_intent';
export const YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT_ROUTE = '/yardi/voyager_deposit_close_intent';
export const YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT_ROUTE = '/yardi/voyager_deposit_withhold_intent';
export const YARDI_VOYAGER_EVENT_ROUTE = '/yardi/voyager_event';
export const YARDI_VOYAGER_FLEX_DEPOSIT_INTENT_ROUTE = '/yardi/voyager_flex_deposit_intent';
export const YARDI_VOYAGER_PHONE_ROUTE = '/yardi/voyager_phone';
export const YARDI_VOYAGER_OTHER_OCCUPANT_ROUTE = '/yardi/voyager_other_occupant';
export const YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS_ROUTE = '/yardi/voyager/pmc/custom/column/settings';
export const YARDI_VOYAGER_PMC_STATS_ROUTE = '/yardi/voyager/pmc/stats';
export const YARDI_VOYAGER_PMC_STATS_COLLECTOR_ROUTE = '/yardi/voyager/pmc/stats/collector';
export const YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY_ROUTE = '/yardi/voyager/logs/active/scan';
export const YARDI_VOYAGER_SYSTEM_SETTINGS_ROUTE = '/yardi/voyager/system/settings';
